import { APP_INITIALIZER } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { CasellaConfigService } from '@portal/common';

export function googleMapsInitializer(casellaConfigService: CasellaConfigService): () => Promise<unknown> {
  return async () => {
    const loader = new Loader({
      apiKey: casellaConfigService.config.GOOGLE_MAP_API_KEY,
      version: 'weekly',
    });

    return Promise.all([loader.importLibrary('maps'), loader.importLibrary('places')]);
  };
}

export const GOOGLE_MAPS_INITIALIZER = {
  provide: APP_INITIALIZER,
  useFactory: googleMapsInitializer,
  deps: [CasellaConfigService],
  multi: true,
};
